import { PHOTO_HEADSHOT } from '@/constants/brand';

export default function About() {
  return (
    <section id="ueber-mich" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <div className="rounded-lg overflow-hidden w-full h-[420px] md:h-[520px]">
              <img
                src={PHOTO_HEADSHOT}
                alt="Stephanie Wolf, Diplom-Pädagogin und Mindset-Trainerin – Portrait"
                title="Stephanie Wolf Persönlichkeitsentwicklung Kurskonzepte"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-5 flex items-center gap-4 rounded-lg border border-accent-200 bg-accent-50 p-5">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 shrink-0">
                <i className="ri-lightbulb-flash-line text-xl"></i>
              </span>
              <div>
                <p className="text-lg font-heading font-semibold text-foreground-950">
                  Praxisnah
                </p>
                <p className="text-sm leading-snug text-foreground-700">
                  Aus Erfahrung entwickelt, für die Praxis gemacht.
                </p>
              </div>
            </div>
          </div>

          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 text-primary-800 px-4 py-1.5 text-xs md:text-sm font-semibold">
              <i className="ri-user-heart-line"></i>
              Über mich
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              Stephanie Wolf
            </h2>
            <p className="mt-2 text-sm md:text-base font-medium text-primary-700">
              Diplom-Pädagogin · staatlich anerkannte Wellness- und Mindset-Trainerin
            </p>

            <div className="mt-6 space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              <p>
                Seit vielen Jahren beschäftige ich mich mit der Entwicklung von Methoden
                und Konzepten, die Menschen dabei unterstützen, ihre persönlichen und
                sozialen Kompetenzen zu stärken und ihre eigenen Potenziale zu entdecken.
              </p>
              <p>
                Aus meiner beruflichen Erfahrung und praktischen Arbeit sind meine
                <strong className="text-foreground-950"> praxisorientierten Kurskonzepte</strong>{' '}
                für soziale Kompetenz, Persönlichkeitsentwicklung und die Vorbereitung auf
                den Arbeitsmarkt entstanden.
              </p>
              <p>
                Die Konzepte verbinden fachliche Inhalte mit leicht umsetzbaren Methoden,
                Übungen und Materialien – und ermöglichen Einrichtungen, Kompetenzförderung
                praxisnah und nachhaltig in ihre eigene Arbeit zu integrieren.
              </p>
            </div>

            <blockquote className="mt-7 rounded-lg border-l-4 border-accent-500 bg-background-50 p-5">
              <p className="text-foreground-800 font-heading text-lg md:text-xl italic leading-snug">
                „In jedem Menschen steckt Entwicklungspotenzial."
              </p>
            </blockquote>

            <div className="mt-7 flex flex-wrap gap-3">
              {['Persönlichkeitsentwicklung', 'Soziale Kompetenz', 'Selbstwirksamkeit', 'Resilienz', 'Mindset', 'Emotionale Selbstregulation'].map(
                (tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-secondary-100 text-secondary-900 px-4 py-1.5 text-xs font-semibold"
                  >
                    {tag}
                  </span>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}